var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "loading-preparation" }, [
    _c("div", { staticClass: "loading-content" }, [
      _vm.showSpinner
        ? _c("div", {
            staticClass: "loading-spinner",
            attrs: { "aria-hidden": "true" },
          })
        : _vm._e(),
      _c("h2", { staticClass: "loading-title" }, [
        _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
      ]),
      _vm._m(0),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "loading-track" }, [
      _c("div", { staticClass: "loading-bar" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }